import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-components-specialist-actioncomponents-customer-information',
	templateUrl: './customer-information.component.html'
})
export class CustomerInformationComponent {
  @Input() customer: Boo.Objects.Customer;
  @Input() parentTaskId?: number;
}
